import { render, staticRenderFns } from "./goto-top.vue?vue&type=template&id=05ae144e&"
import script from "./goto-top.vue?vue&type=script&lang=js&"
export * from "./goto-top.vue?vue&type=script&lang=js&"
import style0 from "./goto-top.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports